module.exports = __webpack_public_path__ + "static/media/v34.78bf41f6.mp4";